






































































































































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { $api } from "@/services/ApiService";
import { User, UserRoles, UserRole } from "bancojs";
import { getRoleString } from "./Index.vue";

@Component
export default class AdminUsersEdit extends Vue {
  async created() {
    if (this.$route.params.id) {
      try {
        const res = await $api.client.admin.users
          .get(this.$route.params.id)
          .toPromise();
        this.form.data = Object.assign(this.form.data, res);
      } catch (err) {
        console.log(err);
      } finally {
        this.form.loading = false;
      }
    } else {
      this.form.editing = false;
      this.form.loading = false;
    }
  }

  async saveUser() {
    this.form.data.name =
      this.form.data.firstname + " " + this.form.data.lastname;
    try {
      this.form.saving = true;
      if (this.form.editing) {
        const user = await $api.client.admin.users
          .update(this.form.data.id, this.form.data)
          .toPromise();
      } else {
        const user = await $api.client.admin.users
          .create(this.form.data)
          .toPromise();
      }
      this.form.saving = false;
      this.$router.push("/admin/users");
    } catch (err) {
      console.log(err);
      this.form.saving = false;
    }
  }

  form: {
    data: User;
    signatureFile: File | null;
    loading: boolean;
    saving: boolean;
    editing: boolean;
    validForm: boolean;
  } = {
    data: {
      firstname: "",
      lastname: "",
      dni: "",
      signature: "",
      id: "",
      email: "",
      roles: [],
      state: "ACTIVE",
      name: "",
    },
    saving: false,
    signatureFile: null,
    loading: true,
    editing: true,
    validForm: false,
  };

  rules = {
    required: (val: any) => !!val || "Campo requerido.",
    email: (val: any) => /.+@.+/.test(val) || 'Email inválido.',
  };

  get roles() {
    return UserRoles.map((role) => {
      return { text: getRoleString(role as UserRole), value: role };
    });
  }

  roleDisabled(role: { text: string; value: UserRole }) {
    return role.value != "ADMIN" &&
      this.form.data &&
      this.form.data.roles.includes("ADMIN")
      ? true
      : false;
  }

  toBase64(file: File) {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  }

  @Watch("form.signatureFile")
  async onSignatureFileChange(val: File) {
    if (val) {
      this.form.data.signature = await this.toBase64(val);
    } else {
      this.form.data.signature = "";
    }
  }

  @Watch("form.data.roles")
  onAdminRoleSelect(newValue: UserRole[]) {
    if (newValue.length > 1 && newValue.includes("ADMIN")) {
      this.form.data.roles = ["ADMIN"];
    }
  }
}
